<template>
    <div class="c-services-summary">
        <div class="component">
            <img src="@/assets/car.jpg" alt="BMW" class="c-services-summary__icon"><br>
            <h3 class="text--light">{{lead.registration_number}}</h3>
            <h3 class="text--light text--gray">{{lead.vin}}</h3>
            <p>
                {{ getModels.filter( e => e.id == lead.model_id).map(e => 'BMW '+e.name)[0] }}
            </p>
        </div>
        <div class="component">
            <img src="@/assets/service.jpg" alt="service" class="c-services-summary__icon">
            <br>
            <span v-for="service in getServices.filter(e => lead.services_val.includes(e.val) )">- {{service.name}}<br></span>
        </div>
        <div class="component">
            <img src="@/assets/pin.jpg" alt="pin" class="c-services-summary__icon">
            <div class="mb--1" v-if="getSelectedDealer">
                <strong>{{ getSelectedDealer.name }}</strong>
                <br>
                {{ getSelectedDealer.address }}, {{ getSelectedDealer.postal_code }} {{ getSelectedDealer.city}}
            </div>
            <br>
            Data przyjęcia
            <br>
            <ul v-if="!lead.date">
                <li v-if="lead.date_from">od  {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date_from)] }}  {{ lead.date_from }}</li>
                <li v-else>Możliwie najszybciej</li>
            </ul>
            <ul v-else> 
                <li>{{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date)] }}  {{ lead.date }}</li>
            </ul>
            <br>
            <template v-if="lead.visit_hour_val || lead.hour">
                Godzina przyjęcia
                <br>
                <ul>
                    <li v-if="lead.hour">{{lead.hour}}</li>
                    <li v-else>{{ getTimeOfDay.find(e => e.val == lead.visit_hour_val).name }}</li>
                </ul>
            </template>
            <template v-if="lead.additional_options_val.length > 0">
                <hr class="mt--1">
                <span v-for="additionalOption in getAdditionalOptions.filter(e => lead.additional_options_val.includes(e.val))">
                    &check; {{ additionalOption.name }}<br>
                </span>
                <ul v-if="lead.replacement_car_id" class="mt--1">
                    <li>{{ getReplacementCars.filter(e => e.id == lead.replacement_car_id? e.model : false ).map(e => e.brand+' '+e.model)[0] }}</li>
                </ul>
            </template>
        </div>
        <div class="component">
            <img src="@/assets/comment.jpg" alt="comment" class="c-services-summary__icon">
            <br>
            <template v-if="lead.comment_val">
                Komentarz
                <br>
                ( {{lead.comment_val}} )
            </template>
            <template v-else>
                Brak komentarza
            </template>
        </div>
    </div>
</template>
<script>
    import lead from '@/mixins/lead.js'
    import {mapGetters} from 'vuex';
    export default {
        mixins:[lead],
        computed:{
            ...mapGetters({
                getServices:'definitions/getServices',
                getModels:'definitions/getModels',
                getDealers:'definitions/getDealers',
                getTimeOfDay:'definitions/getTimeOfDay',
                getAdditionalOptions:'definitions/getAdditionalOptions',
                getReplacementCars: 'definitions/getReplacementCars',
                getDetepickerConfig:'definitions/getDetepickerConfig'
            }),
            getSelectedDealer() { return this.getDealers.find( e => e.id == this.lead.dealer_id) }
        }
    }
</script>
<style lang="scss">
    .c-services-summary{
        @media (min-width:1208px) {
            position: sticky;
            top: 1rem;
        }
        &__icon{
            width: 24px;
            // image-rendering: pixelated;
        }
        .component{
            font-size: 1rem;
            margin-bottom: .75rem;
        }
    }
</style>